import React from 'react';
import { FsText } from '@finalsite/wc-react';

export const CommentField = ({ field }) => {
  return <FsText>
    <div dangerouslySetInnerHTML={{ __html: field.rendered_explanation }}/>
  </FsText>;
}
